/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';
import {useTranslation} from 'react-i18next';
import {BolmateProductRow, BolmateSectionCard} from '../../../controls';
import {OverviewReturn} from '../../../../util/interfaces';
import {OverviewSectionState} from '../useOverviewSection';
import {Icon} from '@iconify/react';
import IDate from '@dvrd/idate';
import {DUTCH_DATE_FORMAT} from '../../../../util/constants.ts';

export default function Returns(props: OverviewSectionState<OverviewReturn>) {
    const {items, loading, loadingMore, error, hasMore, onLoadMore} = props;
    const {t} = useTranslation();

    function renderRow(item: OverviewReturn, index: number) {
        return (
            <BolmateProductRow
                key={index}
                className='stretch-center'
                imageUrl={item.image_url}
                imageBadge={<Icon icon='mdi:keyboard-return' />}
                imageBadgeTitle={t('overview.returns.badgeTooltip', 'Retour')}
                imageBadgeColor='red'
                title={item.title}
                titleHref={item.product_url}
                ean={item.ean}
                subtitle={new IDate(item.return_date).format(DUTCH_DATE_FORMAT)}
                returnItem={item}
            />
        );
    }

    return (
        <BolmateSectionCard
            title={t('overview.sections.returns', 'Retouren')}
            loading={loading}
            loadingMore={loadingMore}
            empty={!items.length}
            emptyLabel={t('overview.returns.empty', 'Geen retouren in deze periode')}
            error={error ? t('overview.sectionError', 'Deze sectie kon niet geladen worden') : undefined}
            hasMore={hasMore}
            loadMoreLabel={t('overview.loadMore', 'Meer laden')}
            onLoadMore={onLoadMore}
        >
            {items.map(renderRow)}
        </BolmateSectionCard>
    );
}
